import { render } from "./ScheduleGabunganPage.vue?vue&type=template&id=726f4852&scoped=true"
import script from "./ScheduleGabunganPage.vue?vue&type=script&lang=js"
export * from "./ScheduleGabunganPage.vue?vue&type=script&lang=js"

import "./ScheduleGabunganPage.vue?vue&type=style&index=0&id=726f4852&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726f4852"]])

export default __exports__